__turbopack_context__.v({
  "content": "delivery-item-module-scss-module__oXw0GW__content",
  "deliveryItem": "delivery-item-module-scss-module__oXw0GW__deliveryItem",
  "iconWrapper": "delivery-item-module-scss-module__oXw0GW__iconWrapper",
  "isDelivery": "delivery-item-module-scss-module__oXw0GW__isDelivery",
  "modal": "delivery-item-module-scss-module__oXw0GW__modal",
  "modalContent": "delivery-item-module-scss-module__oXw0GW__modalContent",
});
